import { jsxs, jsx } from "react/jsx-runtime";
import { useId } from "react";
/* empty css          */
function SegmentedControl({
  value,
  onChange,
  options,
  ariaLabel
}) {
  const name = useId();
  return /* @__PURE__ */ jsxs("fieldset", { className: "graphiql-segmented-control", children: [
    ariaLabel && /* @__PURE__ */ jsx("legend", { className: "graphiql-segmented-control-legend", children: ariaLabel }),
    options.map((opt) => /* @__PURE__ */ jsxs("label", { className: "graphiql-segmented-control-option", "data-checked": opt.value === value || void 0, "data-disabled": opt.disabled || void 0, children: [
      /* @__PURE__ */ jsx("input", { className: "graphiql-segmented-control-input", type: "radio", name, value: opt.value, checked: opt.value === value, disabled: opt.disabled, onChange: () => onChange(opt.value) }),
      opt.icon && /* @__PURE__ */ jsx("span", { className: "graphiql-segmented-control-icon", children: opt.icon }),
      /* @__PURE__ */ jsx("span", { children: opt.label })
    ] }, opt.value))
  ] });
}
export {
  SegmentedControl
};
//# sourceMappingURL=index.js.map
